import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {HashRouter} from "react-router-dom";
import {App} from "./App";

//**************** da sostituire con i moduli ********************
import 'animate.css';

import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import './assets/style/css/customCSS.css';
//**************** da sostituire con i moduli ********************

import store from './store';
import './monacoEditorLoader';


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <HashRouter>
            <App/>
        </HashRouter>
    </Provider>);